export default "__VITE_ASSET__Bli33Srh__"